<template>
  <div class="modal fade" id="mod-purchase-filter" role="dialog">
    <div
      class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
    >
      <form
        @submit.prevent="submit"
        class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
      >
        <div class="modal-header- flex items-start justify-between p-0 m-0">
          <h4
            class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
          >
            Filter
          </h4>
          <button
            class="text-2xl text-[#353535] outline-none focus:outline-none"
            type="button"
            data-dismiss="modal"
            aria-hidden="true"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div class="m-0 p-0">
          <div class="pb-[16px]">
            <label class="text=[#353535] font-medium text-[14px] leading-[20px]"
              >PO Number</label
            >
            <div>
              <input
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                type="text"
                placeholder="Filter by PO Number"
                v-model="orderNumber"
              />
            </div>
          </div>
          <div>
            <label class="text=[#353535] font-medium text-[14px] leading-[20px]"
              >Status</label
            >
            <div>
              <select
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                v-model="status"
                placeholder="Select an option"
              >
                <option
                  v-for="option in statusItem"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="flex items-center gap-[8px] w-full mt-[32px]">
          <button
            class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
            type="button"
            data-dismiss="modal"
          >
            Cancel
          </button>
          <button
            class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
            type="button"
            @click="reset"
          >
            Reset
          </button>
          <button
            class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
            type="submit"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterPurchase",

  data() {
    return {
      orderNumber: "",
      status: "",
      statusItem: [
        { name: "Submitted", value: "submitted" },
        { name: "Draft", value: "draft" },
        { name: "Approved", value: "approved" },
        { name: "Rejected", value: "rejected" },
        { name: "Closed", value: "close" },
      ],
    };
  },

  created() {
    this.getOrderStages();
  },

  methods: {
    reset() {
      this.orderNumber = "";
      this.status = "";
    },
    submit() {
      this.$emit("onFilter", {
        orderNumber: this.orderNumber,
        status: this.status,
      });
    },
    async getOrderStages() {
      try {
        const response = await this.$http.get(
          "/PurchaseOrders/orderStage/getList?active=true"
        );

        if (response.ok && response.status === 200) {
          this.orderStages = response.body.sort(
            (firstItem, secondItem) => firstItem.stage - secondItem.stage
          );
        }
      } catch (error) {}
    },
  },
};
</script>
